import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import * as React from "react";
import { useEffect, useState } from "react";

import {
  AssetCategoryIdFilter,
  Category,
} from "../../../generated/gql/graphql";
import useCategories from "../../../hooks/query/use-categories";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import { cn } from "../../../utils/utils";

import { styles } from "./metashot-type-filter";

type Props = {
  className?: string;
  value?: AssetCategoryIdFilter;
  onSelect(value: Category | "all"): void;
};

export default function CategoryFilter(props: Props): React.ReactElement {
  const { className, value, onSelect } = props;
  const { strings } = useText(local);

  const [options, setOptions] = useState<Category[]>([]);
  const { data, loading, error } = useCategories();

  useEffect(() => {
    if (!data) {
      return;
    }

    setOptions([]);
  }, [data]);

  function internalSelect(id: string): void {
    const el = options.find((o) => o.id === id);
    if (!el) {
      // eslint-disable-next-line no-console
      console.info(`unable to find options with id: ${id}`);
      return;
    }

    onSelect(el);
  }

  return (
    <Box sx={styles}>
      <FormControl
        style={{ minWidth: 150, maxWidth: 200 }}
        size="small"
        className="disabled:cursor-not-allowed "
      >
        <InputLabel className="text-[14px]">{strings.label}</InputLabel>
        <Select
          className={cn(
            "border-0 rounded-[15px] text-[14px] text-left",
            className
          )}
          displayEmpty
          //   disabled={options.length === 0 || loading || !!error}
          label={strings.label}
          value={value?.toString() ?? "all"}
          onChange={(v) => internalSelect(v.target.value as string)}
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value="all">{strings.options.all}</MenuItem>
          {options &&
            options.map((item) => (
              <MenuItem
                className="capitalize"
                key={item.id + item.name}
                value={item.id}
              >
                {item.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}

type LocalSchema = {
  label: string;
  options: {
    all: string;
  };
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Category",
    options: {
      all: "All",
    },
  },
};
